
// tiny, dependency-free
const Any = Symbol('Any');
function Union(...types) { return { kind: 'union', types }; }
function List(of)       { return { kind: 'list', of }; }
function Dict(key, val) { return { kind: 'dict', key, val }; }
function Tuple(...ts)   { return { kind: 'tuple', types: ts, variadic: false }; }
function TupleV(t)      { return { kind: 'tuple', types: [t], variadic: true }; }
const Callable = { kind: 'callable' };

// helpers to test JS “classes” used as types (String, Number, Boolean, Object, Array, Date, YourModel, etc.)
function isCtor(t) { return typeof t === 'function'; }

////
//// --------------
////
class BaseData {
  // --- Schema declaration style (closest to your Python) ---
  // Subclasses provide either/both:
  //   static annotations = { field: TypeOrSpec | [TypeOrSpec, default], ... }
  //   static get_keys()  => { required: {k: TypeOrSpec}, optional: {k: TypeOrSpec} }
  // Wildcard via '*' key in required/optional.
  static annotations = undefined;
  static get_keys() { return { required: {}, optional: {} }; }

  constructor(inObj = {}, { trim = false, env = {} } = {}) {
    if (inObj == null || typeof inObj !== 'object' || Array.isArray(inObj)) {
        console.log( {inObj});
      throw new Error('BaseData expects a plain object:');
    }

    // 1) Merge schema: annotations + get_keys
    const { required, optional, defaults } = this._collectSchema(); 
    // Not seeing these console logs
    console.log({defaults});
    console.log({optional});
    console.log({required});
    // Expose <field> constants on instance (parity with Python)
    Object.keys(defaults).forEach(k => { 
        if (!(k in inObj)) {
            inObj[ k] = defaults[k]; 
            console.log(`loaded defaults ${k}`);  
        }
    });
    //Object.keys(required).forEach(k => { if (k in inObj) this[ k] = inObj[k]; console.log(`required ${k}`);  });
    //Object.keys(optional).forEach(k => { if (k in inObj) this[ k] = inObj[k]; console.log(`optional ${k}`);   });

    // 2) Preprocess
    inObj = this.do_pre_process({ ...inObj });
    console.log({inObj});
    console.log(`pre processed: ${inObj}`);
    if (!inObj || typeof inObj !== 'object') throw new Error('do_pre_process must return an object');

    // 3) Env mapping (<<VAR>>)
    inObj = this._envMap(inObj, env);

    console.log(`_envMap: ${inObj}`);
    console.log({inObj});
    // 4) Trim unknowns (optional)
    // if (trim) {
    //   const allowed = new Set([...Object.keys(required), ...Object.keys(optional)]);
    //   Object.keys(inObj).forEach(k => { if (!allowed.has(k)) delete inObj[k]; });
    // }

    if (trim) {
    const allowed = new Set(Object.keys(this._types).filter(k => k !== '*'));
        for (const k of Object.keys(inObj)) {
            if (!allowed.has(k)) delete inObj[k];
        }
    }
    console.log(`trim: ${inObj}`);


    console.log({inObj});


    // 5) Validate/convert required
    Object.entries(required).forEach(([k, spec]) => {
      this._validateAndConvert(inObj, k, spec); // ensures presence & type
      if (!(k in inObj) && k !== '*') throw new Error(`Missing required key: ${k}`);
    });
    console.log(`_validateAndConvert: ${inObj}`);
    console.log({inObj});

    // 6) Validate/convert optionals (if present)
    Object.entries(optional).forEach(([k, spec]) => {
      if (k in inObj) this._validateAndConvert(inObj, k, spec);
    });

    // 7) Wildcard
    const wildcard = required['*'] || optional['*'];
    if (wildcard) {
      Object.keys(inObj).forEach(k => {
        if (!(k in required) && !(k in optional)) {
          this._validateAndConvert(inObj, k, wildcard);
        }
      });
    }

    console.log(`_validateAndConvert-*: ${inObj}`);
    console.log({inObj});
    // 8) Post-pass validation over all keys
    Object.entries(inObj).forEach(([k, v]) => {
      const [newVal, msg] = this.do_every_validation(k, v);
      if (msg && msg.length) throw new Error(msg);
      inObj[k] = newVal;
      this[k] = inObj[k];
    });

    console.log(`Final: ${this}`);
    Object.entries(this).forEach(([k, val]) => {

        console.log(`Final ${k}:`,val);


    })


    this._types = { 
    ...required, 
    ...optional 
    };
    //if (required['*'] !== undefined) this._types['*'] = required['*'];
    //if (optional['*'] !== undefined) this._types['*'] = optional['*'];    

    return new Proxy(this, {
    has: (t, p) => (p in t) || Object.prototype.hasOwnProperty.call(t._data, p),

    get: (t, p, r) => {
        //if (p in t) return Reflect.get(t, p, r);
        //if (Object.prototype.hasOwnProperty.call(t, p)) 
        //{
        //    return t.do_get_filtered(p, t[p]);
        //}
        return t[p];
    },

    // set: (t, p, v, r) => {
    //     // allow overwriting own non-function props
    //     console.log(`calling proxy ${t}`);
    //     if (p in t && typeof t[p] !== 'function') { t[p] = v; return true; }

    //     // validate against declared types (incl. wildcard)
    //     const spec = (p in t._types) ? t._types[p] : t._types['*'];
    //     if (spec !== undefined) {
    //     const box = { [p]: v };
    //     t._validateAndConvert(box, p, spec);
    //     t._data[p] = box[p];
    //     return true;
    //     }

    //     // otherwise treat as plain instance prop
    //     t[p] = v;
    //     return true;
    // }
////////

set: (t, p, v, r) => {
  // ---- Readable aliases (no behavior change) ----
  const target   = t;
  const prop     = String(p);
  const newValue = v;
  const receiver = r;

  // ---- Inputs ----
  console.log("Proxy.set called");
  console.log("target:", target);
  console.log("prop:", prop);
  console.log("newValue:", newValue);
  console.log("receiver:", receiver);

  // ---- Branch 1: overwrite own non-function prop ----
//   const isOwnNonFunction =
//     (prop in target) && (typeof target[prop] !== "function");
//   console.log("isOwnNonFunction:", isOwnNonFunction);

//   if (isOwnNonFunction) {
//     console.log("action: assign to target[prop]");
//     target[prop] = newValue;
//     console.log("result target[prop]:", target[prop]);
//     return true;
//   }

  // ---- Branch 2: validate against declared types (incl. wildcard) ----
  const declaredTypes   = target._types;
  const hasDeclaredType = declaredTypes
    ? Object.prototype.hasOwnProperty.call(declaredTypes, prop)
    : false;
  const wildcardSpec    = declaredTypes ? declaredTypes["*"] : undefined;
  const typeSpec        = hasDeclaredType ? declaredTypes[prop] : wildcardSpec;

  console.log("declaredTypes keys:", declaredTypes ? Object.keys(declaredTypes) : null);
  console.log("hasDeclaredType:", hasDeclaredType);
  console.log("wildcardSpec exists:", wildcardSpec !== undefined);
  console.log("typeSpec:", typeSpec);

  if (typeSpec !== undefined) {
    const box = { [prop]: newValue };
    console.log("pre-validate box:", box);
    target._validateAndConvert(box, prop, typeSpec);
    console.log("post-validate box:", box);
    //target._data[prop] = box[prop];
    target[prop] = box[prop];
    console.log("assigned target._data[prop]:", target[prop]);
    return true;
  }

  // ---- Branch 3: plain instance prop ----
  console.log("no typeSpec found; assigning as plain instance prop");
  target[prop] = newValue;
  console.log("result target[prop]:", target[prop]);
  return true;
}


////////
    
    });

  }
  // --- ----

    // Recursively coerce/init values according to the spec (mirrors Python field-level init + deep container walk)
    _coerceBySpec(spec, value) {
        // 0) passthroughs
        if (spec === Any) return value;

        // 1) custom converter function: (v) or (self, v)
        if (typeof spec === 'function' && !isCtor(spec)) {
            return (spec.length >= 2) ? spec(this, value) : spec(value);
        }

        // 2) direct nested BaseData model
        if (isCtor(spec) && this._isBaseDataCtor(spec) && this._isPlainObject(value)) {
            return new spec(value); // child validates itself
        }

        // 3) container specs (recurse into children)
        if (spec && spec.kind === 'list') {
            if (!Array.isArray(value)) return value; // let _validType complain later
            return value.map(v => this._coerceBySpec(spec.of, v));
        }

        if (spec && spec.kind === 'dict') {
            if (!value || typeof value !== 'object' || Array.isArray(value)) return value;
            const out = {};
            for (const [k, v] of Object.entries(value)) {
            // keys: no coercion (validation happens in _validType)
            out[k] = this._coerceBySpec(spec.val, v);
            }
            return out;
        }

        if (spec && spec.kind === 'tuple') {
            if (!Array.isArray(value)) return value;
            if (spec.variadic) return value.map(v => this._coerceBySpec(spec.types[0], v));
            if (value.length !== spec.types.length) return value;
            return value.map((v, i) => this._coerceBySpec(spec.types[i], v));
        }

        if (spec && spec.kind === 'union') {
            // Try branches; return first coercion that ends up valid
            for (const t of spec.types) {
            try {
                const out = this._coerceBySpec(t, value);
                if (this._validType(out, t)) return out;
            } catch (_) { /* try next */ }
            }
            return value; // let _validType fail later
        }

        if (spec && spec.kind === 'callable') {
            return value; // _validType will enforce function
        }

        // 4) primitives/ctors (Number/String/Boolean/Object/etc.) – no coercion here
        return value;
    }


  // --- Hooks (override in subclasses) ---
  do_pre_process(obj) { return obj; }
  do_validation(key, value) { return [value, '']; }
  do_every_validation(key, value) { return [value, '']; }
  do_get_filtered(key, value) { return value; }

  // --- Public helpers (API parity) ---
  get(key) { return this.do_get_filtered(key, this._data[key]); }
  set(key, val) { this._setItem(key, val); return true; }
//   clean() {
//     const { required, optional } = this._collectSchema();
//     const allowed = new Set([...Object.keys(required), ...Object.keys(optional)]);
//     const sliced = {};
//     allowed.forEach(k => { if (k in this._data) sliced[k] = this._data[k]; });
//     return new this.constructor(sliced);
//   }
    clean() {
        const allowed = Object.keys(this._types).filter(k => k !== '*');
        const sliced = {};
        for (const k of allowed) {
            if (k in this._data) sliced[k] = this._data[k];
        }
        return new this.constructor(sliced);
    }


  toSafeObject(target = this._data) {
    if (target && typeof target.toSafeObject === 'function' && target !== this) {
      return target.toSafeObject();
    }
    if (Array.isArray(target)) return target.map(v => this.toSafeObject(v));
    if (target && typeof target === 'object') {
      const out = {};
      Object.entries(target).forEach(([k, v]) => { out[k] = this.toSafeObject(v); });
      return out;
    }
    if (typeof target === 'function') return target.name || 'Function';
    return target;
  }
  toJSON() { return this.toSafeObject(this._data); } // JSON.stringify support

  // --- Internals ---
//   _allKeys() {
//     const { required, optional } = this._collectSchema();
//     return { ...required, ...optional };
//   }

//   _setItem(key, value) {
//     const all = this._allKeys();
//     const spec = (key in all) ? all[key] : (all['*'] || undefined);
//     if (!spec) { this._data[key] = value; return; }
//     const box = { [key]: value };
//     this._validateAndConvert(box, key, spec);
//     this._data[key] = box[key];
//   }

_setItem(key, value) {
  const spec = (key in this._types) ? this._types[key] : this._types['*'];
  if (spec === undefined) { this._data[key] = value; console.log(`Missing spec for ${key}`); return; }
  const box = { [key]: value };
  this._validateAndConvert(box, key, spec);
  this._data[key] = box[key];
}

  _collectSchema() {
    // annotations: { k: TypeOrSpec | [TypeOrSpec, default] }
    const ann = this.constructor.annotations || {};
    const annReq = {};
    const annOpt = {};
    const defaults = {};
    Object.entries(ann).forEach(([k, v]) => {
      if (Array.isArray(v) && v.length === 2) { annOpt[k] = v[0]; defaults[k] = v[1]; }
      else { annReq[k] = v; }
      
    });

    const { required: req2, optional: opt2 } = this.constructor.get_keys() || { required: {}, optional: {} };
    // conflict detection
    const conflicts = Object.keys(ann).filter(k => (k in req2) || (k in opt2));
    if (conflicts.length) throw new Error(`Conflicting key definitions: ${conflicts.join(', ')}`);

    return {
      required: { ...annReq, ...req2 },
      optional: { ...annOpt, ...opt2 },
      defaults
    };
  }

  _envMap(value, env) {
    const RX = /<<([A-Z_][A-Z0-9_]*)>>/g;
    const sub = (s) => s.replace(RX, (_, name) => {
      if (!(name in env)) throw new Error(`Missing env var: ${name}`);
      return String(env[name]);
    });
    if (Array.isArray(value)) return value.map(v => this._envMap(v, env));
    if (value && typeof value === 'object') {
      const out = {};
      Object.entries(value).forEach(([k, v]) => { out[k] = this._envMap(v, env); });
      return out;
    }
    if (typeof value === 'string') return sub(value);
    return value;
  }

  _validateAndConvert(obj, key, spec) {
    obj[key] = this._coerceBySpec(spec, obj[key]);
    // 1) converter function(s): (v) or (self, v)
    if (typeof spec === 'function' && !isCtor(spec)) {
      obj[key] = (spec.length >= 2) ? spec(this, obj[key]) : spec(obj[key]);
    } else if (isCtor(spec) && this._isBaseDataCtor(spec) && this._isPlainObject(obj[key])) {
      // 2) nested BaseData from plain object
      obj[key] = new spec(obj[key]);
    }

    // 3) per-field do_validation (may coerce)
    const [newVal, message] = this.do_validation(key, obj[key]);
    obj[key] = newVal;

    // 4) present-but-None rule (mirror Python: allow if Any or default==null)
    if (obj[key] == null && spec !== Any) {
      // (we can’t see default here; the behavior matches your present-None rejection unless Any)
      throw new TypeError(`Validation produced null/undefined for key '${key}':'${JSON.stringify(obj)}'`);
    }

    // 5) type check (skip if Any or converter function)
    if (spec !== Any && !(typeof spec === 'function' && !isCtor(spec))) {
      if (!this._validType(obj[key], spec)) {
        throw new TypeError(`Expected ${this._specToString(spec)} for '${key}', got ${this._jsType(obj[key])}`);
      }
    }
  }

  _validType(val, spec) {
    if (spec === Any) return true;

    // Union
    if (spec && spec.kind === 'union') {
      return spec.types.some(t => this._validType(val, t));
    }

    // List
    if (spec && spec.kind === 'list') {
      if (!Array.isArray(val)) return false;
      return val.every(x => this._validType(x, spec.of));
    }

    // Dict
    if (spec && spec.kind === 'dict') {
      if (!val || typeof val !== 'object' || Array.isArray(val)) return false;
      return Object.entries(val).every(([k, v]) =>
        this._validType(k, spec.key) && this._validType(v, spec.val));
    }

    // Tuple
    if (spec && spec.kind === 'tuple') {
      if (!Array.isArray(val)) return false; // JS tuples ≈ arrays
      if (spec.variadic) return val.every(x => this._validType(x, spec.types[0]));
      if (val.length !== spec.types.length) return false;
      return val.every((x, i) => this._validType(x, spec.types[i]));
    }

    // Callable
    if (spec && spec.kind === 'callable') return typeof val === 'function';

    // Ctor/class (Number/String/Boolean/Object/Date/YourModel etc.)
    if (isCtor(spec)) {
      if (spec === Number) return typeof val === 'number' && !Number.isNaN(val);
      if (spec === String) return typeof val === 'string';
      if (spec === Boolean) return typeof val === 'boolean';
      if (spec === Array) return Array.isArray(val);
      if (spec === Object) return !!val && typeof val === 'object' && !Array.isArray(val);
      return val instanceof spec;
    }

    return false;
  }

  _isPlainObject(x) { return !!x && typeof x === 'object' && !Array.isArray(x); }
  _isBaseDataCtor(f) { return typeof f === 'function' && f.prototype instanceof BaseData; }
  _specToString(s) { return (s && s.kind) ? s.kind : (isCtor(s) ? (s.name || 'Function') : String(s)); }
  _jsType(v) { return (v === null) ? 'null' : Array.isArray(v) ? 'array' : typeof v; }
}



////
//// --------------
////

class SomeOtherObject extends BaseData {
  static annotations = {}; // minimal
}

class ModernFloatRangeExampleClass extends BaseData {
  // Python:
  //   min: (float, 0.0)
  //   index: float
  //   ref: SomeOtherObject
  //   max: (float, 1.0)
  static annotations = {
    min:   [Number, 0.0],
    index: Number,
    ref:   SomeOtherObject,
    max:   [Number, 1.0],
  };

  do_validation(key, value) {
    console.log("---- do_validation called ----");
    console.log("key:", key);
    console.log("value:", value);
    console.log("this.min:", this.min);
    console.log("this.index:", this.index);
    console.log("this.max:", this.max);    
    if (key !='index') return [value, ''];
    if (value < this.min) 
    {
        value = this.min;

    }
    if (value > this.max)
    {
        value = this.max;
    } 

    return [value, '']
  }
}


export {
  Any, Union, List, Dict, Tuple, TupleV, Callable, isCtor,
  BaseData,
  SomeOtherObject,
  ModernFloatRangeExampleClass
};

if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    Any, Union, List, Dict, Tuple, TupleV, Callable, isCtor,
    BaseData,
    SomeOtherObject,
    ModernFloatRangeExampleClass
  };
}